import { trackEvent } from '../util/analytics'
import { flushNextPageEvents } from '../tracking'
import type { CompilerMeta } from 'types/unpoly/compiler'

up.compiler(
  '[data-track-page-view]',
  (element: HTMLElement, data: Record<string, unknown>, meta: CompilerMeta) => {
    // We use a [data-track-page-view] element that is rendered on every request to
    // allow tracking when page contents are updated through Unpoly.
    // URL data is sent from the server as `up-data`.

    if (meta.revalidating) {
      return
    }

    const eventData = Object.assign({}, data, {
      percentage: 0,
      page: {
        title: document.title,
        modal: up.layer.isOverlay(),
      },
    })

    trackEvent('page.view', eventData)
    flushNextPageEvents()
  },
)
